import l from "./ghl-ui.es1207.js";
function f(e, n) {
  var t = e == null ? 0 : e.length;
  return !!t && l(e, n, 0) > -1;
}
export {
  f as default
};
